import { type SeatStatus, seatLegendStyles } from "./seatColors";

interface LegendItem {
  label: string;
  status: SeatStatus;
}

const legendItems: LegendItem[] = [
  { label: "空", status: "available" },
  { label: "自分の予約", status: "own" },
  { label: "他の人の予約", status: "occupied" },
];

export function SeatLegend() {
  return (
    <div className="flex flex-wrap gap-4 text-sm">
      {legendItems.map((item) => (
        <div key={item.label} className="flex items-center gap-2">
          <div
            className={`w-4 h-4 rounded border-2 ${seatLegendStyles[item.status]}`}
            aria-hidden="true"
          />
          <span className="text-gray-600">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
